import { createStyles, Theme } from "@material-ui/core";
export const userStyles = (theme: Theme) =>
 
  createStyles({ 
    customInfoIcon: {
      width: '20px',
      marginLeft: '5px',
      position: 'relative',
      top: '4px',
    },
    searchSelectDropdown: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      '&>div:nth-child(2)>div.dropdownBox>div': {
        '&>div:first-child': {
          borderColor: '#E6E6E6',
          borderRadius: '4px',
          height: '44px',
          lineHeight: '42px',
          width: '154px',
          padding: '0 10px',
          fontSize: 14,
          '& .lightGrey': {
            fontWeight: 600,
            color: '#666666',
          },
          '& span:last-child img': {
            marginLeft: 0,
            width: '10px',
            filter: 'brightness(0)',
          },
        },
        '&>div.dropDownlisting': {
          borderColor: '#E6E6E6',
          borderRadius: '4px',
          padding: '10px',
          top: '50px',
          maxHeight: '180px',
          "&::-webkit-scrollbar": {
            width: '4px',
          },
          "&::-webkit-scrollbar-track": {
            background: '#999999',
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: '#bdbdbd',
            borderRadius: '10px',
            border: '0px solid #ffffff',
          },
          '& .textField': {
            padding: 0,
            borderColor: '#E6E6E6',
            fontSize: 14,
            '& input': {
              padding: '0 25px 0 6px',
              height: '36px',
            }
          },
          '& .listingItem': {
            padding: 0,
            marginBottom: 12,
            '&:hover': {
              backgroundColor: 'transparent',
            },
            '& .checkboxPl0': {
              paddingLeft: 0,
              '& svg': {
                fill: '#CACACA',
              },
              '&.checkdCheckbox svg': {
                fill: '#1D7DEA',
              }
            },
            '& .checkboxText': {
              fontSize: 14,
              fontWeight: 400,
              color: '#666666',
              marginLeft: 5,
              marginTop: 3,
              wordBreak: 'break-word',
            },
          },
          '& .searchCloseIcon': {
            position: 'absolute',
            right: 20,
            top: 20,
            cursor: 'pointer',
          }
        }
      },
    },
    noGoalFound:{
      display: 'block',
      textAlign: 'center',
      fontSize: 18,
      color: '#666',
      paddingTop: 6
    },
    cursor: {
     cursor: "pointer"
    },
    
    rightText: {
      fontSize: 16,
      color: "#666",
      margin: '10px 0',
      "& span": {
        fontWeight: 600,
      },
    },
    justifyEnd: {
      justifyContent: 'flex-end'
    },
  manageSearchList:{
    // maxHeight: 78,
    checkboxLabel:{
      
    }
  },
  historyContainer: {
    display: 'flex',
    width: '90px',
    margin: '12px 0 12px auto'
  },
  historyCTA: {
    marginRight: '10px',
    '& img': {
      marginRight: '10px'
    }
  },
  dNone: {
    display: "none"
  },
	border: {
		border: 'solid 1px rgb(188 188 188)'
	},
	paddingRightSM: {
		padding: "0px 9px 0px 0",
	},
	paddingLeftSM: {
		padding: "0px 0px 0px 9px",
	},
  mt72:{
    marginTop: '72px!important',
  },
    sideContainer:{
      position: 'relative',
      marginTop: 80,
    },
    tooltipDetails: {
      position: 'absolute',
      marginTop: 24,
      zIndex: 999999
  },
  padding30:{
    padding: '0px 30px'
  },
  clickable: {
    cursor: 'pointer'
  },
  countColunmwidth:{
    width:80,
    paddingRight:20,
    paddingLeft:14,
  },
    saveDialogContainer: {
      '& .paraDetails': {
      marginLeft: "auto",
    marginRight: "auto",
    width: "30em",
    padding: "12px 30",
      },
    '& p': {
      fontSize:16,
      fontWeight:400,
      padding:'14px 0px 26px',
      color: '#333',
      lineHeight: '22px'
    },
    '& button': {
      width: 175,
      margin: '10px 0px 16px'
    }
    },
    sectionInContentContainer: {
      width: "100%",
      backgroundColor: "#fff",
      borderRadius: "4px",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      padding: "20px",
      marginBottom: 10,
    },
    heading: {
      fontWeight: 700,
      fontSize: "17px",
      marginBottom: "20px",
    },
    initialStatusContainer: {
      width: "28px",
      height: "28px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "1px solid #e1e1e1",
      borderRadius: "50%",
    },
    verticleLine: {
      border: '0.5px solid #333333',
      margin: '0 12px',
      backgroundColor: '#333'
    },    
    tabContainer: {
      padding: "12px 0",
      borderBottom: "0.5px solid rgb(210 210 210)",
      paddingBottom:6,
      // margin: "0px 12px",
      height: "73px"
    },
    fullModal: {
      overflowY: 'auto',
      background: '#fbfbfb',
      overflowX: 'hidden',
      padding: '0 12px',
      height: '100%',
      zIndex: 1200,
      '&>:first-child': {
        outline: 0
      }
    },
    cardTitle:{
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      width:500,
      overflow: "hidden",
    },
    iconWidth:{
      width: 20,
      height: 44,
    },
    textCenter:{
      textAlign: 'center'
    },
    dividerSpacing:{
      margin: "0 0 10px 0",
      display: "block",
    },
    yourTaskTable: {
        "& thead": {
          "& tr": {
            "& th": {
              fontSize: 14,
              fontWeight: 600,
              color: "#333",
              padding: "4px 10px 4px 10px",              
              whiteSpace: 'nowrap',
              textAlign: "center"
            },
            "&>:first-child": {
              padding: "4px 10px 4px 10px",
              textAlign: "center"
            },
            "&>:nth-child(3)": {
              //width: 135,
            },
            "&>:nth-child(5)": {
              //width: 180,
            },
            "&>:nth-child(2), &>:nth-child(8)": {
              //width: 72,
              textAlign: "center",
              padding: "4px 20px 4px 22px",
            },
            "&>:nth-child(6)": {
              //width: 200,
              textAlign: "center",
              padding: "4px 20px 4px 22px",
            },
            "&>:nth-child(7)": {
              //width: 115,
              textAlign: "center",
              padding: "4px 20px 4px 22px",
            },
          },
        },
        "& tbody": {
          "& tr": {
            backgroundColor: "#fff",
            "& td": {
              fontSize: 14,
              fontWeight: 400,
              color: "#666",
              border: "1px solid #DFDFDF",
              padding: "18px 12px 18px 12px",
              verticalAlign: "middle",
              textAlign: "center",
              lineHeight: '25px',
              "& svg": {
                fill: "#67BF02",
              },
            },
            "&>:first-child": {
              padding: "4px 10px 4px 10px",
              textAlign: "center",
              //width: 40,
            },
            "&>:nth-child(2), &>:nth-child(8)": {
              //width: 60,
              textAlign: "center",
              padding: "6px 12px 6px 12px",
            },
            "&>:nth-child(6)": {
              //width: 200,
              textAlign: "center",
              padding: "6px 12px 6px 12px",
            },
            "&>:nth-child(7)": {
              //width: 115,
              textAlign: "center",
              padding: "6px 12px 6px 12px",
            },
            "&>:last-child": {
              color: "#1d7dea",
              fontWeight: 600,
              cursor: "pointer",
            },
          },
        },
    },
    tableBg: {
      "& thead": {
        "& tr": {
          "& th": {
            fontSize: 14,
            fontWeight: 600,
            color: "#333",
            padding: "4px 10px 4px 10px",
            textAlign: 'center',
          },
          "&>:first-child": {
            padding: "4px 10px 4px 10px",
            textAlign: "center",
            width: 40,
          },
          "&>:nth-child(3)": {
            width: 135,
          },
          "&>:nth-child(5)": {
            width: 180,
          },
          "&>:nth-child(2), &>:nth-child(8)": {
            width: 72,
            textAlign: "center",
            padding: "4px 20px 4px 22px",
          },
          "&>:nth-child(6)": {
            width: 200,
            textAlign: "center",
            padding: "4px 20px 4px 22px",
          },
          "&>:nth-child(7)": {
            width: 115,
            textAlign: "center",
            padding: "4px 20px 4px 22px",
          },
        },
      },
      "& tbody": {
        "& tr": {
          backgroundColor: "#fff",
          "& td": {
            fontSize: 14,
            fontWeight: 400,
            color: "#666",
            border: "1px solid #DFDFDF",
            padding: "18px 12px 18px 12px",
            verticalAlign: 'text-top',
            lineHeight: '25px',
            textAlign: 'center',
            "& svg": {
              fill: "#67BF02",
            },
          },
          "&>:first-child": {
            padding: "4px 10px 4px 10px",
            textAlign: "center",
            width: 40,
          },
          "&>:nth-child(2), &>:nth-child(8)": {
            width: 60,
            textAlign: "center",
            padding: "6px 12px 6px 12px",
          },
          "&>:nth-child(6)": {
            width: 200,
            textAlign: "center",
            padding: "6px 12px 6px 12px",
          },
          "&>:nth-child(7)": {
            width: 115,
            textAlign: "center",
            padding: "6px 12px 6px 12px",
          },
          "&>:last-child": {
            color: "#1d7dea",
            fontWeight: 600,
            cursor: "pointer",
          },
        },
      },
    },
    // content Owner deadline 
    vTOp:{
      "& tbody": {
        "& tr": {
          "& td": {
            verticalAlign: 'top'
          }
        }
      }
    },
    contentOwnerDeadlineTable:{
// border:'0.5px solid #999999'
'& thead':{
  '& th':{
    fontSize:16
  }
},
      '& tbody':{
        '& tr':{
          '& td':{
            border: '1px solid #ddd',
            lineHeight: '26px',
            fontSize: 16,
            padding: '4px 25px 4px 24px'
          },
          '&>:nth-child(5)':{
            paddingRight: 10,
          }
        }
      }
    },
    fontBold:{
      fontWeight: 600,
      color: '#666',
      marginRight: 5,
      fontSize: 14,
    },
    grayFont:{
      color: '#666',
      fontWeight: 'normal',
      fontSize: 14,
    },
    // End
    requestMoreIcon: {
      position: 'relative',
      zIndex: 3,
      padding: '0px 12px 35px 20px',
      margin: '0px 8px',
      '&>:first-child': {
        position: 'absolute',
        top: -4,
        zIndex: 9
      }
    },
    sidePanel: {
      '& > *': {
        marginBottom: 16,
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.12)',
        borderRadius: 4
      },
      '&': {
        width: '100%',
        height: '100%',
      }
    },    
    questionBorder: {
      borderLeft: 'solid 6px #78D2A7'
    },

    testBorder: {
      borderLeft: 'solid 6px #F49393'
    },
    
    marginTop70: {
      marginTop: 70
    },
    switchGrid:{
      display:'flex',
    },
    panelHeading:{
      fontSize: 16,
      fontWeight: 600,
      color: '#666',
      marginBottom: 13,
    },
    swithMain:{
      marginBottom: 10,
    },
    switchBar:{
      height: 22,
      marginTop: '-11px',
      width: 44,
      borderRadius: 20,
      marginLeft: '-17px',
      backgroundColor: '#acacac',
      opacity: 1
    },
    IscheckedSwitch:{
      opacity: 1,
      marginRight: '-17px',      
    },
    checkedSwitch:{
      color: '#fff', 
      marginRight: '-17px',  
      opacity: 1,   
      '& + $switchBar': {
        opacity: 1,
      },
    },
    switchIcon:{
      backgroundColor: '#fff'
    },
    customDropdownBox: {
      position: 'absolute',
      marginTop: 130,
      background: 'rgb(255 255 255)',
      border: '0.5px solid #999999',
      boxShadow: '0px 5px 2px rgba(0, 0, 0, 0.05)',
      borderRadius: 4,
      '& .deleteAction': {
        '& svg': {
          fill: '#F44335',
          margin: '0px 12px'
        },
        padding: '10px 12px',
        cursor: 'pointer',
        '&:hover': {
          background: 'rgb(102 102 102 / 3%)'
        }
      },
      '& .editAction': {
        '& svg': {
          fill: '#1d7dea',
          margin: '0px 12px'
        },
        '& img': {
          width: 20,
          margin: '0px 12px'
        },
        padding: '10px 12px',
        cursor: 'pointer',
        '&:hover': {
          background: 'rgb(102 102 102 / 3%)'
        }
      },
      '&::after': {
        position: 'absolute',
        content: '" "',
        top: -6,
        right: 9,
        width: 10,
        height: 10,
        background: 'rgb(255 255 255)',
        borderRight: '0.5px solid #999999',
        borderTop: '0.5px solid #999999',
        transform: 'rotate(-45deg)',
        webkitTransform: 'rotate(-45deg)'
      }
    },
    labelText: {
      '& :nth-child(2)': {
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: 16,
          lineHeight: '19px',
          color: '#333333',
          marginTop: 2
      }
  },
    btnCreateGoal: {
      marginTop: 20,
    },
    marginTop12: {
      marginTop: 12
    },
    fontWeight400: {
      fontWeight: 400
    },
    fontWeight600: {
      fontWeight: 600
    },
    fontSize10: {
      fontSize: 10
    },
    fontSize14: {
      fontSize: 14
    },
    blackColor: {
      color: '#333'
    },
    lightGreyColor: {
      color: '#999'
    },
    darkGreyColor: {
      color: '#666'
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
     
      right: -6
    },
    expandOpen: {
      transform: 'rotate(180deg)',
    },
    checkBoxElement: {
      padding: '0px 7px',
      top: 0,
      width: 20,
      height: 20,
      '-moz-appearance': 'none',
      opacity: 1,
      color: 'rgb(204, 204, 204)',
      border: '1px solid #B2B2B2',
      borderRadius: 2,
      margin: '-4px 14px 0px 16px',
      '& svg': {
        fontSize: '1.5rem',
        fontFamily: '"Nunito", sans-serif',
        fill: '#979797',
        opacity: 0
      },
      '& span:nth-child(1)': {
        width: 24,
        zIndex: 9
    }
    },
    
    checkboxLabel: {
      fontSize: 18,
      color: '#666',      
    },
    truncate:{
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
      display: "inline-block",
      width: 180
    },
    formControlLabel: {
      marginBottom: 6
    },
    checkedCheckbox: {
      backgroundColor: '#1d7dea!important',
      border: '1px solid #1d7dea !important',
      borderRadius: 2,
      color: '#99a1a7',
      '&::after': {
        content: "''",
        fontSize: 14,
        position: 'absolute',
        top: 1,
        left: 6,
        width: 4,
        height: 10,
        border: 'solid #fff',
        borderWidth: '0 2px 2px 0',
        transform: 'rotate(45deg)'
      },
      '&:hover': {
        backgroundColor: '#1d7dea'
      }
    },
    primaryColor: {
      color: 'rgb(29 125 234)'
    },
    customCard: {
      background: '#FFFFFF',
      boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
      borderRadius: 8,
      marginBottom: 15,
      cursor: 'pointer',
      overflow: 'inherit'
    },
    goalCardDefault: {
      height: '47px'
    },
    filterContainer: {
      padding: '12px 0px 10px 0px'
    },
    cardHeader: {
      fontSize: '1rem',
      fontFamily: '"Nunito", sans-serif',
      color: 'rgba(50, 60, 71, 1)',
      width: '100%',
      padding: '0px 16px 0px',
      '& h6':{
        fontWeight: 600,
        fontSize: 16,
        lineHeight: '22px',
        color: '#333333'
      }
    },
    customChip: {
      padding: '3px 0px',
      maxWidth: 126,
      background: '#FFF',
      border: '1px solid #1d7dea',
      boxSizing: 'border-box',
      borderRadius: 10,
      height: 20,
      margin: 6
    },
    chipLabel: {
      display: 'block',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      fontFamily: '"Nunito", sans-serif',
      textOverflow: 'ellipsis',
      fontWeight: 600,
      fontSize: 12,
      color: '#1d7dea',
      textTransform: 'capitalize'
    },
    requestCardFooter: {
      background: 'rgba(249, 249, 249, 0.88)',
      padding: '10px 16px',
      '& .priorityBox': {
        '& span:nth-child(1)': {
          verticalAlign: 'middle',
          display: 'flex'
        },
        '& span:nth-child(2)': {
          color: '#999',
          fontSize: 14,
          fontWeight: 600
        },
        '& span:nth-child(3)': {
          fontSize: 14,
          color: '#666',
          fontWeight: 600
        }
      }
    },
    progressBar: {
      borderRadius: 5
    },
    linearProgressBar: {
      borderRadius: 5,
      padding: 2,
      margin: '4px 8px',
      backgroundColor: '#E8E8E8',
      width: '28%',
      display: 'inline-block',
      verticalAlign: 'middle'
    },
    linearProgressBar1: {
      borderRadius: 5,
      padding: 2,
      margin: '10px 4px 10px 7px',
      backgroundColor: '#E8E8E8',
      width: 54
    },
    progressPercent:{
      fontSize: 10,
      color: '#333'
    },
    colorSecondary: {
      backgroundColor: '#EB4F4F',
      color: '5.5px 5px 5px 5.5px'
    },
    colorprimary: {
      backgroundColor: '#1d7dea',
      color: '5.5px 5px 5px 5.5px'
    },
    progressLabel:{
      fontSize: 14,
      color: '#666'
    },
    resumeButton:{
      color: '#1d7dea',
      fontSize: 16,
      textTransform: 'uppercase',
      fontWeight: 600
    },
    requestStatusLabel: {
      borderRadius: 4,
      padding: '6px 10px',
      fontSize: 10,
      fontWeight: 600,
      marginLeft: 8
    },
    inContentRequest: {      
      background: 'rgba(29, 125, 234, 0.08)',
      color: '#1D7DEA;'
    },
    inRequestCreation: {
      background: 'rgba(184, 129, 227, 0.14)',
      color: '#AD6FDE'
    },
    dropdownContainer: {
      '&>:first-child': {
        width: '100%',
        maxWidth: 320,
        '&>:first-child': {
          minWidth: 250,
        },
        '&>:nth-child(2)': {
          maxWidth: 320,
          width: '100%'
        }
      }
    },
    requestCardContent: {
      padding: '0px 26px 8px 16px',
      marginTop:-7,
      '& .verticleSpacing': {
        margin: "4px 0",
        display: "inline-block",
      },
      '& .pushRight':{
        textAlign: 'right',
        marginRight: 25,
      },
      '& span:nth-child(1)': {
        color: '#999',
        fontSize: 14,
        fontWeight: 400,
        marginRight: 5,
      },
      '& span:nth-child(2)': {
        color: '#666',
        fontSize: 14,
        fontWeight: 400
      }
    },
    marginBottom2x: {
      marginBottom: 16,
  },
  okButton: {
    fontFamily: 'Nunito',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '19px',
    letterSpacing: '0.5px',
    color: '#FFFFFF',
    background: '#1D7DEA',
    padding: '4px 22px',
    maxWidth: 150,
    borderRadius: 4,
    '&:hover': {
        background: '#1D7DEA'
    }
},

    contentPublished: {
      background: 'rgba(103, 191, 2, 0.1);',
      color: '#59A600'
    },
    noDataContainer: {
      width: '100%',
      padding: '0px 0px 0px 60px',
      height: 'calc(100% - 30px)',
      '& .noData':{
        paddingTop: 120,
      }
    },
    fullHeight:{
      height: 'calc(100% - 30px)'
    },
    searchNew: {
      '&>:first-child':{
      borderRadius:'25px',
      width:'35vw'
      },
    },
    epansionPanelBody: {
      padding: "8px 16px 70px",
    alignItems: "center",
    '& .dropdownBox': {
      right:16,
    position: "absolute",
    maxWidth: '100%',
    width: "auto",
    left: 16
    }
    },
    crDateCollapse: {
      '& .scrollbar-container': {
        width: 274,
        overflowX: 'auto',
        paddingBottom: 20,
        padding: 0,
        position: 'absolute'
      },
    },
    scrollBarX: {
      display: 'flex',
      padding: '8px 16px 0px',
      alignItems: 'center',
      paddingBottom: '0px !important',
      '& .scrollbar-container': {
        width: '100%',
        overflowX: 'auto',
        paddingBottom: 20,
        padding: 0,
        height:'168px',
      }
    },
    scrollBarXWithoutContent: {
      display: 'flex',
      padding: '8px 16px 0px',
      alignItems: 'center',
      paddingBottom: '0px !important',
      '& .scrollbar-container': {
        width: 274,
        overflowX: 'auto',
        paddingBottom: 20,
        padding: 0,
        height:'47px',
      }
    },
    collapsibleContainer: { 
      zIndex: 4,
      width: '100%'
    },
    tabPanel: {
      marginTop: 20,
      marginBottom: 12, 
      // background: 'rgb(255 255 0)',
      position: 'absolute',
      right: 0,
      left: 0,
      top: '100%',
      width: "calc(100vw - 130px)",        
      '& .subPanel': {
        color: 'rgb(153 153 153)',
        padding: "0",
        fontSize:16,
        fontWeight:600,
        cursor: 'pointer',
        '& > *': {
          cursor: 'pointer',
        }
      },   
      '& .activeTab':{
        color: '#1D7DEA'
      }, 
    },    
  //  
  whiteCard:{
    background: '#FFF',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
    borderRadius: 4,
    padding: '32px 24px',
    '& ::placeholder':{
        color: '#999',
        fontSize: 12,
        fontWeight: 'normal'
    },
  },
  // request card date 
  cardDate:{
    fontSize: 16,
    color: '#666',
    marginBottom: 10,
    display: 'inline-block'
  },  
  // Dialog : Add Test Owners & Specify Their Deadlines
  mainHeading:{
    fontSize: 20,
    fontWeight: 600,
    color: '#333',
    marginBottom: 5,
  },
  subHeading:{
    fontSize: 16,
    color: '#999'
  },
  inputLable:{
    fontSize: 14,
    color: '#333',
    marginBottom: 10,
    display: 'inline-block',
  },
  disable: {
    opacity: 0.5,
    cursor: "default"
    // pointerEvents: 'none'
  },
  disableTab: {
    opacity: 0.5,
    pointerEvents: 'none'
  },
  // End

  red:{
    color: '#F23C3C!important'
  },
  darkYellow:{
    color: '#FB9E2E!important'
  },
  yellow:{
    color: '#FFD016!important'
  },
  green:{
    color: '#30BE76!important'
  },
  // Cr Date range
  dateRangePicker:{
    border: "1px solid #DFDFDF",
    padding: "14px 16px",
    marginTop:55,
    borderRadius:4,
    marginBottom:15,
    position: "relative",
    '& .rdrDateDisplayItem': {
      // boxShadow: "0px 0px 6px 1px rgb(35 57 66 / 21%)",
      border: "1px solid rgb(223 223 223)",      
      '&:hover': {
        boxShadow: "0px 2px 6px 1px rgb(35 57 66 / 21%)",
        border: "1px solid rgb(223 223 223)",
      }
    },
    '& .rdrMonthAndYearWrapper': {
      padding: "10px 12px 10px 12px",
    },
    '& .rdrNextPrevButton': {
      width:24,
      height:38,
      margin: "-0.997em",
    },
    '&>:nth-child(2)':{
      '&>:first-child':{
        width: '100%',
        '&>:first-child':{
          backgroundColor: 'transparent',
          '&>:first-child':{
            margin: 0,
          },
        },
        '&>:nth-child(3)':{
         '&>:first-child':{
          width: '100%'
         }
        }
      }
    },

  },
  dateRangeCollapse: {
    width: "100%",
    border: "1px solid rgb(223 223 223)",
    padding: "10px 3px 10px 2px",
    borderRadius:4,
    position: 'relative',
    top: 56,
    '&>:first-child':{
      '&>:first-child':{
        '&::after': {
          top: 7,
          position: "absolute",
          borderRight: "solid 1px rgb(188 188 188)",
          left: "50%",
          height: "78%",
          padding: "0px 2",
          content: '" "'
        },
        // padding: 6
      },
      '&>:nth-child(2)':{
        // padding: 6
      }
    },
    '& .dateLabelPanel': {
      '&>:nth-child(2)':{
        color: "rgb(51 51 51)",
        fontSize: 12,
        fontWeight:500,
        lineHeight:'28px',
      },
    },
    '&:hover': {
      background: 'rgb(251 251 251)'
    }
  },
  dateLabel:{
    fontSize:12,
    fontWeight:400,
    color: '#666',
    textTransform: "uppercase",
  },
  dateLabelText:{
    fontSize: 16,
    color: '#666',
    marginBottom: 10,
    display: 'inline-block'
  },

  fontSize16: {
    fontSize: 16
  },
  textCapitalize: {
    textTransform: 'capitalize'
  },
  searchContainer: {
    margin: "12px 0px",
    position: "relative",
    width: "394px !important",
    '@media(max-width: 1365px)': {
      width: '370px !important',
    },
    "& img": {
      position: "absolute",
      top:12,
      left:10,
      width:20,
      marginRight: "10px",
    },
    "& input": {
      padding: "8px 10px 8px 40px",
      fontSize:16,
      borderRadius:30,
      border: "0.5px solid rgb(223 223 223)",
      height:44,
      width: "100%",
      "&:focus":{
        outline: "none"
      }
    }
  },

  // CR progress Timeline
  dotsSeperator:{
    margin: '0 10px'
  },
  // After Assignment
  summaryContentTitle:{
    fontSize: 14,
    color: '#333',
    fontWeight: 600,
    textTransform: 'uppercase'
  },
  contentTitle:{
    fontSize: 14,
    color: '#333',
    fontWeight: 600,
  },
  contentSubTitle:{
    fontSize: 14,
    color: '#666',
  },
  ExpTitle:{
    fontSize: 16,
    color: '#666',
  },
  ExpSubTitle:{
    fontSize: 16,
    color: '#333',
  },
  smallWidth:{
    width:100,
    paddingRight:0,
  },
  largeWidth:{
    width:265,
    paddingRight:0,
  },
  paddingR0:{
    paddingRight: 0,
    lineHeight:'20px'
  },
  statusText: {
		textTransform: 'capitalize',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		fontSize: 14,
		color: '#666666',
		padding: '4px 0px'
	},
  navBar: {
    padding: '18px 12px 20px',
    '& .label': {
        color: '#999',
        verticalAlign: 4
    },
    '& .subLabel': {
        // color: '#666',
        verticalAlign: 4
    },
    '& .red': {
      color: 'red',
     },
     '& .darkYellow': {
    color: 'darkYellow',
     }, 
     '& .yellow': {
    color: 'yellow',
     },      
     '& .green': {
     color: 'green',  
      },
    '& .Assigned_by': {
      fontWeight:600,
      color: "#333",
    },
    '& .Request_owner': {
      fontWeight:600,
      color: "#666",
    },
  },
  courseRadioGroup:{
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    '&>label':{
      marginLeft: '-13px',
      '&>:nth-child(2)':{
        fontSize: 18,
        color: '#666'
      },
    },
  },
  customInput:{
    '&>input':{
      border: 'none',
      padding: '0px 8px 8px 8px',
      '&:hover':{
        outline: 'none',
        border: 'none'
      },
      '&:focus':{
        outline: 'none',
        border: 'none'
      },
      '& ::placeholder':{
        color: "#999",
        fontWeight: 'normal',
        fontSize:14,
        fontFamily: '"Nunito", sans-serif',
      },
    }
  },
  marginTop20:{
    marginTop: 20,
  },
  DialogContainer:{
    '&>div:nth-of-type(1)':{
      '&>div:nth-of-type(1)':{
        display: 'flex',
        flexDirection: 'row-reverse',
        '&  p':{
          fontSize: 20,
          display: 'flex',
          alignItems: 'center',
          '& img':{
            marginRight: 10,
          }
        },

        '&>div:nth-of-type(2)':{
          '& button':{
            transform: "scale(1.4)",
            marginRight: 10,
          },
        }
      }
    },
  },
  addtionalDes:{
    maxHeight: 150,
    overflow: "auto",
    display: "flex",
    justifyContent: "center",
  },
  addtionalDes1:{
    maxHeight: 200,
    overflow: "auto",
    display: "flex",
    justifyContent: "center",
  },
  tableContainer: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
    '& th':{
      padding: '4px 40px 4px 30px',
    },
    '& td':{
      padding: '10px 40px 10px 30px',
    }
  },
  bulkReportrow: {
    '& th':{
      padding: '4px 40px 4px 25px',
    },
    '& td':{
      padding: '10px 40px 10px 25px',
    },
    "& thead": {
      '& th':{
        padding: '4px 52px 4px 24px',
      },
    }
  },
  progressContainer:{
    display: 'flex',
    alignItems: 'center',
    '& progress':{
      margin: '0 10px 0 auto',
      maxWidth: 100,
    },
  },
  coursePlanChangeTab: {
    border: 'solid 1px rgba(153, 153, 153, 0.4)',
    borderRadius: '4px',
    display: 'inline-flex',
    listStyle: 'none',
    padding: 0,
    margin: '4px 0 20px',
    overflow: 'hidden',
    '& li': {
      borderRight: 'solid 1px rgba(153, 153, 153, 0.4)',
      padding: '11px 15px',
      fontSize: '16px',
      fontWeight: 400,
      color: '#666666',
      cursor: 'pointer',
      '&.current': {
        backgroundColor: '#1D7DEA',
        borderColor: '#1D7DEA',
        color: '#ffffff',
      },
      '&:last-child': {
        borderRight: 0,
      }
    }
  },
  coursePlanChangeRequestRow: {
    position: 'relative',
    '& .coursePlanChangeRequestCol': {
      backgroundColor: '#FFFFFF',
      borderRadius: '8px',
      width: '100%',
      padding: '16px 20px',
      marginBottom: '12px',
      '&:last-child': {
        marginBottom: 0,
      },
      '& h2': {
        fontSize: '24px',
        fontWeight: 600,
        lineHeight: '32px',
        color: '#333333',
        margin: '0 0 12px',
      },
      '& .courseNameRow': {
        display: 'flex',
        alignItems: 'center',
        '& .courseNameCol': {
          width: '50%',
          fontSize: '16px',
          fontWeight: 400,
          color: '#666666',
          display: 'inline-flex',
          alignItems: 'center',
          '& .courseIcon': {
            marginRight: '10px',
          },
          '& span': {
            marginTop: '3px',
          }
        },
        '& .courseDate': {
          width: '50%',
          textAlign: 'right',
          fontSize: '16px',
          fontWeight: 400,
          color: '#333333',
          '& span': {
            color: '#999999',
          }
        },
      },
      '& .requestedList': {
        borderTop: 'solid 1px #DDDDDD',
        padding: '16px 0 0',
        margin: '16px 0 0',
        display: 'flex',
        alignItems: 'center',
        listStyle: 'none',
        '& li': {
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '20px',
          color: '#666666',
          '&::after': {
            content: "''",
            width: '4px',
            height: '4px',
            borderRadius: '50%',
            backgroundColor: '#D9D9D9',
            display: 'inline-block',
            verticalAlign: 'middle',
            margin: '0 10px',
          },
          '&:last-child::after': {
            display: 'none',
          },
          '& span': {
            color: '#333333',
          }
        }
      },
      },
    },
    searchSelectRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
    }
  // goalFilterHeight:{
  //   '&>div:nth-of-type(1)':{
  //     height: 'initial',
  //   }
  // }
 });
